var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather-icon',{attrs:{"icon":_vm.icon,"svgClasses":{
    status_icon: true,
    completed: this.type === 'completed',
    not_completed: this.type !== 'completed',
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }